/*eslint-disable */
import React, { useState, useEffect } from "react";
import {
  Button,
  Modal,
  Form as FormUi,
  Icon,
  Dropdown,
} from "semantic-ui-react";
import { withFormik, Field as Fieldmik, FieldArray } from "formik";
import ReadAxios from "../axiosComponent/read";
import { isEmpty } from "lodash";
import CreateAxios from "../axiosComponent/create";
import { connect } from "react-redux";
import { MyInput, MyNormalInput, MyTextArea } from "../dynamicComponent/myInputs";
import {
  successAlertDispatcher,
  errorAlertDispatcher,
} from "../../redux/actions/alertAction";
import { translate } from "react-i18next";
import * as yup from 'yup';
import { FEATURES } from "../../utils/constant";

const ModalAllot = ({
  values,
  isSubmitting,
  touched,
  errors,
  handleSubmit,
  setFieldValue,
  t,
  role,
  ...props
}) => {
  const [modalOpen, setmodalOpen] = useState(false);
  const [Vendors, setVendors] = useState([]);
  const billingPartyAvail =
    Number(localStorage.getItem("customerNumber")) == 1122 ||
    Number(localStorage.getItem("customerNumber")) == 984 ||
    Number(localStorage.getItem("customerNumber")) == 1167 ||
    Number(localStorage.getItem("customerNumber")) == 1123 ||
    Number(localStorage.getItem("customerNumber")) == 1077 ||
    Number(localStorage.getItem("customerNumber")) == 1305
      ? "notallowed"
      : "allowed";

  const [billingParty, setBillingParty] = useState(billingPartyAvail);

  useEffect(() => {
    getAllVendors();
  }, []);
  let handleOpen = () => {
    if (Number(localStorage.getItem("customerNumber")) == 1123) {
      allotWithoutModal();
    } else {
      setmodalOpen(true);
    }
  };
  let handleClose = () => {
    setmodalOpen(false);
  };
  let handleSubmited = () => {
    setmodalOpen(false);
    if (values.vendor) handleSubmit();
  };

  const allotWithoutModal = () => {
    let suggestedVendorPresence = props.order.map((item, index) => {
      return props.order[index].suggested_vendor_id;
    });
    let suggestedVendorPresenceAttr = true;
    for (let i = 0; i < suggestedVendorPresence.length; i++) {
      suggestedVendorPresenceAttr =
        suggestedVendorPresenceAttr && suggestedVendorPresence[i];
    }
    if (billingParty == "notallowed" && suggestedVendorPresenceAttr) {
      var MyArray = []; //

      for (let index = 0; index < props.order.length; index++) {
        if (props.order[index].vendor_order_id == null)
          MyArray.push(props.order[index].suggested_vendor);
      }

      for (let index = 0; index < props.order.length; index++) {
        const element = props.order[index].vendor_order_id;
        let vendor = props.order[index].suggested_vendor_id;
        MyArray.push(props.order[index].suggested_vendor); //
        CreateAxios({
          completeURL: `${process.env.REACT_APP_TA_API_URL}/orders/${element}/allocate/vendor/${vendor}`,
          payload: { vendor },
        })
          .then((res) => {
            // props.successAlertDispatcher({
            //   type: "success",
            //   messageHeader: "Success",
            //   messageBody:
            //     "Alloted To Suggested Vendor " + " " + MyArray.join(" and "), //res.data.message,
            // });
            //window.location.reload();
            // props.reFetchOrder();
            if (index + 1 === props.order.length) {
              props.successAlertDispatcher({
                type: "success",
                messageHeader: "Success",
                messageBody:
                  "Alloted To Suggested Vendor " + " " + MyArray.join(" and "), //res.data.message,
              });
              MyArray.length = 0;
              window.location.reload();
            }

            console.log("suggested vendor", res.data.suggested_vendor);
          })
          .catch((err) => {
            props.successAlertDispatcher({
              type: "error",
              messageHeader: "Error",
              messageBody: err.message,
            });
          });
      }

      // if (MyArray.length > 0) {
      //   props.successAlertDispatcher({
      //     type: "success",
      //     messageHeader: "Success",
      //     //MyArray.join("\n"),
      //     messageBody:
      //       "Alloted To Suggested Vendor " + " " + MyArray.join(" and "), //('", "') + '"', //("\n"),
      //   });
      // }
      //window.location.reload();
      // alert("Alloted To Suggested Vendor" + MyArray.join("\n")); //
    } else if (suggestedVendorPresenceAttr === null) {
      props.successAlertDispatcher({
        type: "error",
        messageHeader: "Error",
        messageBody: "Provide vendor to allot",
      });
    } else {
      setmodalOpen(true);
    }
  };

  const getAllVendors = () => {
    ReadAxios({ url: `transporterMaster` })
      .then((res) => {
        isEmpty(res.data.resultSet)
          ? setVendors([])
          : setVendorsState(res.data.resultSet);
      })
      .catch((err) => setVendors([]));
  };
  const setVendorsState = (dataArray) => {
    let result = dataArray.map((item, index) => {
      return {
        raw: { ...item },
        text: `${item.transporterName} (${item.transporterCode})`,
        key: item.transporterCode,
        value: item.transporterMasterId,
      };
    });
    setVendors(result);
  };

  const customerNo = localStorage.getItem("customerNumber");

  return (
    <div>
      <Modal
        open={modalOpen}
        onClose={handleClose}
        size="tiny"
        trigger={
          <Button
            circular
            size="mini"
            type="button"
            onClick={handleOpen}
            disabled={role == "Broker" ? true : false}
            className="w3-blue w3-round w3-hover-blue"
          >
            {t("title_button") || "Allot"}
          </Button>
        }
      >
        <Modal.Header className="p-bold-100">
          {t("title") || "Allot Shipment"}
        </Modal.Header>
        <Modal.Content scrolling>
          <Modal.Description style={{ height: "10em" }}>
            <div className="ui form">
              <FormUi.Field width={12}>
                <label className="labelName mt-2">
                  {t(
                    customerNo != 1158 ? "vendor.vendor_title" : "vendor.title"
                  ) || "Select Vendor"}
                </label>
                <Dropdown
                  name="vendor"
                  clearable
                  search
                  style={{ width: "100%" }}
                  selection
                  placeholder={
                    t(
                      customerNo != 1158
                        ? "vendor.vendor_placeholder"
                        : "vendor.placeholder"
                    ) || "Select Vendor"
                  }
                  onChange={(name, data) => setFieldValue("vendor", data.value)}
                  options={Vendors}
                  defaultValue={values.vendor}
                />
              </FormUi.Field>
              <FormUi.Field width={12}>
                <label className="labelName mt-2">
                  {t(
                    customerNo != 1158
                      ? "vendor_branch.vendor_title"
                      : "vendor_branch.title"
                  ) || "Partner Branch"}
                </label>
                <Dropdown
                  className="mr-1 checkselect"
                  name="vendor_branch"
                  clearable
                  style={{ width: "100%", fontWeight: "normal" }}
                  // disabled={disable}
                  selection
                  placeholder={
                    t(
                      customerNo != 1158
                        ? "vendor_branch.vendor_placeholder"
                        : "vendor_branch.placeholder"
                    ) || "Partner Branch"
                  }
                  onChange={(name, data) =>
                    setFieldValue("vendor_branch", data.value)
                  }
                  options={[
                    { key: "2", text: "Delhi", value: "delhi" },
                    { key: "3", text: "Mumbai", value: "mumbai" },
                    { key: "1", text: "Bangalore", value: "bangalore" },
                  ]}
                />
              </FormUi.Field>
              {FEATURES.CHECK_ALL_ALLOW_ROLE(role) ? (
                <FormUi.Field
                  width={12}
                  // error={
                  //   touched.final_rate &&
                  //     errors.final_rate
                  //     ? true
                  //     : false
                  // }
                >
                  <label className="labelName mt-2">
                    {t("final_rate.title") || "Final Rate"}
                  </label>
                  <Fieldmik
                    component={MyNormalInput}
                    type="number"
                    name="freight_rate"
                  />
                  {/* {touched.final_rate &&
                  errors.final_rate ? (
                    <div className="w3-text-red w3-tiny">
                      {props.t(
                        `final_rate.error_msg.${errors.final_rate}`
                      ) || errors.final_rate}
                    </div>
                  ) : null} */}
                </FormUi.Field>
              ) : null}
              {FEATURES.CHECK_ALL_ALLOW_ROLE(role) ? (
                <>
                  <FormUi.Field
                    width={12}
                    style={{ padding: "0 0 10px 0" }}
                  >
                    <label className={(localStorage.getItem("customerNumber") == 1166 || localStorage.getItem("customerNumber") == 1165) ? "required-form-element" : ""}>{t("remarks") || "Remarks"}</label>
                    <Fieldmik
                      placeholder={values.remarks}
                      component={MyTextArea}
                      name="remarks"
                    />
                    {touched.remarks && errors.remarks ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.remarks}</strong> : ''}
                  </FormUi.Field>

                </>
              ) : (
                null
              )}
            </div>
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          {/* {isSubmitting ? "Loading..." : ""} */}
          {(localStorage.getItem("customerNumber") == 1166 || localStorage.getItem("customerNumber") == 1165) ?
            <Button
              type="submit"
              onClick={handleSubmit}
              disabled={isSubmitting || (values.remarks && values.vendor) ? false : true}
              size="mini"
              className="w3-blue w3-round w3-hover-blue"
            >
              {t("action_button.submit") || "Submit"}
            </Button>
            :
            <Button
              type="submit"
              onClick={handleSubmit}
              disabled={isSubmitting || (values.vendor) ? false : true}
              size="mini"
              className="w3-blue w3-round w3-hover-blue"
            >
              {t("action_button.submit") || "Submit"}
            </Button>
          }
        </Modal.Actions>
        {/* </Formiker> */}
      </Modal>
    </div>
  );
};
const FormikModalAllot = withFormik({
  mapPropsToValues(props) {
    return {
      vendor_paceholder:
        props.order &&
        props.order?.length == 1 &&
        props.order?.[0]?.suggested_vendor_id &&
        props.billingParty == "allowed"
          ? props.order[0].suggested_vendor
          : "",
      vendor:
        props.order &&
        props.order?.length == 1 &&
        props.order?.[0]?.suggested_vendor_id &&
        props.billingParty == "allowed"
          ? props.order[0].suggested_vendor_id
          : "",
      freight_rate: 0,
      vendor_branch: "",
      remarks: "",
    };
  },

  validationSchema: yup.object({
    customer: yup.mixed(),
    remarks: yup.mixed().when('customer', {
      is: (customer) => {
        console.log("Customer Number ========>", customer);
        return customer && (customer == 1165 || customer == 1166) ? true : false
      },
      then: yup.string().required('Remarks is Mandatory'),
      otherwise: yup.string().optional()
    }),
  }),
  handleSubmit(values, { setSubmitting, props }) {
    console.log("in allot", props, values);
    for (let index = 0; index < props.order.length; index++) {
      const element = props.order[index].vendor_order_id;
      console.log("in for loop");
      CreateAxios({
        completeURL: `${process.env.REACT_APP_TA_API_URL}/orders/${element}/allocate/vendor/${values.vendor}`,
        payload: { ...values },
      })
        .then((res) => {
          setSubmitting(false);
          console.log(res);
          props.successAlertDispatcher({
            type: "success",
            messageHeader: "Success",
            messageBody: res.data.message,
          });
          // props.reFetchOrder();
          window.location.reload();
        })
        .catch((err) => {
          console.log(err);
          props.successAlertDispatcher({
            type: "error",
            messageHeader: "Error",
            messageBody: err.message,
          });
        });
    }
  },
})(ModalAllot);

export default connect(null, { successAlertDispatcher, errorAlertDispatcher })(
  translate("allot")(FormikModalAllot)
);
